import React, { useEffect, useState } from 'react';
import {useLocation, useNavigate } from 'react-router-dom';
import { useAttendanceStore } from ".././AttendanceSummaryReport/store/useAttendanceStore";
import { TableLoader } from '../../../../Common/ShimmerLoader';
import MUITable from '../../../../Common/MUITable';
import { ExportSupportingStaffDetails } from './ExportsAttendanceSummary/ExportSupportingStaffDetails';
const SupportingStaffDrillDown = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isFetchingSupportingStaffDetails, fetchSupportingStaffDetails, supportingStaffDetails  } = useAttendanceStore();
 

  const supportingStaffDetailsColumns = [
    {
      label: "Operation Name",
      field: "operationName",
      render: (row) => row.operationName,
    },
    {
      label: "Designation",
      field: "designationName",
      render: (row) => row.designationName,
    },
    {
      label: "Planned Attendance",
      field: "plannedAttendance",
      render: (row) => row.plannedAttendance,
    },
    {
      label: "Biometric Attendance",
      field: "biometricAttendance",
      render: (row) => row.biometricAttendance,
    },
    {
      label: "Forced Attendance",
      field: "forcedAttendance",
      render: (row) => row.forcedAttendance,
    },
    {
      label: "BA + FA",
      field: "bA_FA",
      render: (row) => row.bA_FA,
    },
    {
      label: "Shortfall",
      field: "shortfall",
      render: (row) => row.shortfall,
    },
    {
      label: "Attendance %",
      field: "attendancePercentage",
      render: (row) => row.attendancePercentage,
    },
  ];

  return (
    <>
    <div className="content">
      <div className="page-content">
      <h4 className="text-start mb-3">Supporting Staff Drill-Down</h4>
        <div className="page-header">
          <div className="card mt-3">
            <div className="">
              <div className="d-flex justify-content-end mt-3 mb-3 mr-3">
                <ExportSupportingStaffDetails />
                <button className="btn btn-secondary me-2 ml-3" type="button" onClick={() => navigate(-1)}>
                  Back
                </button>
              </div>
             
               <MUITable
                needSRNumber
                columns={supportingStaffDetailsColumns}
                rows={supportingStaffDetails  || []} // Ensure it's an array
                tableHeight={500}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default SupportingStaffDrillDown;
